import { omit } from 'lodash';
import qs from 'qs';
import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as SMHIcon } from 'src/assets/images/smh-icon.svg';
import styled from 'styled-components';
import { FormattedDate } from '../../../components/formatted-date/formatted-date';
import { StatusBadge } from '../../../components/status-badge/status-badge';
import { TD } from '../../../components/table/table';
import { IOrder, ProcessStatus } from '../../../graphql/types';
import { getUserID } from '../../../libs/auth/index';
import { Medium } from '../../../styles/fonts';
import { orderDetailsRoute } from '../../order-details/route';
import { ORDERS_PAGE_ROUTE } from '../route';

const StyledText = styled.div`
  font-family: ${Medium};
`;

const NameAndIconContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const SMHIconContainer = styled.div`
  margin-left: 0.5rem;
`;
export const SwitchRejectStatus = (status: ProcessStatus): string => {
  switch (status) {
    case 'APPROVED':
      return 'Approved';
    case 'RELEASED':
      return 'Released';
    case 'PARTIALLY_BLOCKED':
      return 'Partially rejected';
    case 'BLOCKED':
      return 'Rejected';
    default:
      return '';
  }
};

export const OrdersTableBody: FC<{ orders: IOrder[] }> = ({ orders }) => {
  const params = omit(
    qs.parse(useLocation().search, { ignoreQueryPrefix: true }),
    'shipToId',
    'uid'
  );
  const location = useLocation();
  let queryString = qs.stringify(params, { addQueryPrefix: true });
  // quick fix to not break the link for soldto/ with query is empty
  if (queryString.length < 1) {
    queryString = '?';
  }
  const uid = getUserID();
  return (
    <tbody>
      {orders.map(order => {
        // const shipToLink = `${ORDERS_PAGE_ROUTE}/${order.soldTo.id}${queryString}&shipToId=${order.shipTo.id}&uid=${uid}`;
        const shipToLink = `${location.pathname}${queryString}&shipToId=${order.shipTo.id}&uid=${uid}`;
        order.id = order.GSAPid;
        return (
          <tr key={order.indexTable.toString()} data-type="order">
            <TD data-type="order-created-on">
              <FormattedDate date={order.createdOn} />
            </TD>
            <TD>
              <Link
                data-type="order-id"
                data-value={order.id}
                to={orderDetailsRoute(
                  order.soldTo.id,
                  { orderId: order.id },
                  order.status,
                  order.shipTo.id
                )}
              >
                {order.id}
              </Link>
            </TD>
            <TD data-type="order-po-id">{order.poID}</TD>
            <TD>
              <NameAndIconContainer>
                <StyledText data-type="order-ship-to-name">
                  {order.shipTo.address.name}
                </StyledText>
                {order.shipTo.smhActiveUser && (
                  <SMHIconContainer data-type="smh-users" title="SMH User">
                    <SMHIcon />
                  </SMHIconContainer>
                )}
              </NameAndIconContainer>
              {order.soldTo.salesOrg !== 'SG88' &&
              order.soldTo.salesOrg !== 'US86' ? (
                <Link data-type="order-ship-to-id" to={shipToLink}>
                  {order.shipTo.id}
                </Link>
              ) : (
                order.shipTo.id
              )}
            </TD>

            <TD data-type="order-vessel-name">
              {order.partnerInfo?.vesselName} <br />
              {order.partnerInfo?.imoNumber} <br />
              {order.partnerInfo?.partnerNumber}
            </TD>

            <TD data-type="order-items-count">{order.itemsCount}</TD>
            <TD data-type="order-status">
              <Link
                to={orderDetailsRoute(
                  order.soldTo.id,
                  { orderId: order.id, poId: order.poID },
                  order.status,
                  order.shipTo.id
                )}
              >
                <StatusBadge
                  title={order.statusLastUpdated}
                  status={order.status}
                />
              </Link>
            </TD>
            <TD data-type="order-reject-status">
              {order.rejectStatus !== 'APPROVED' && (
                <>{SwitchRejectStatus(order.rejectStatus)}</>
              )}
            </TD>
          </tr>
        );
      })}
    </tbody>
  );
};
